"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isNull2 = _interopRequireDefault(require("lodash/isNull"));
var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _cccisdLaravelReport = require("cccisd-laravel-report");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LogReport = /*#__PURE__*/function (_Component) {
  _inherits(LogReport, _Component);
  function LogReport() {
    var _this;
    _classCallCheck(this, LogReport);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, LogReport, [].concat(args));
    // render table cell with a binary value
    _defineProperty(_assertThisInitialized(_this), "_renderBinaryCell", function (value, icon) {
      if ((0, _isNull2["default"])(value) || (0, _isUndefined2["default"])(value)) {
        return /*#__PURE__*/_react["default"].createElement("td", null);
      }
      if (value) {
        return /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("span", {
          className: "icon"
        }, /*#__PURE__*/_react["default"].createElement("svg", {
          width: "20",
          height: "20",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: icon.viewBox,
          style: {
            fill: 'currentColor'
          }
        }, /*#__PURE__*/_react["default"].createElement("g", null, icon.paths.map(function (p) {
          return /*#__PURE__*/_react["default"].createElement("path", {
            key: p,
            d: p
          });
        })))));
      }
      return /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].fade
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "icon"
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        width: "20",
        height: "20",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: icon.viewBox,
        style: {
          fill: 'currentColor'
        }
      }, /*#__PURE__*/_react["default"].createElement("g", null, icon.paths.map(function (p) {
        return /*#__PURE__*/_react["default"].createElement("path", {
          key: p,
          d: p
        });
      })))));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderNull", function () {
      return /*#__PURE__*/_react["default"].createElement("td", null);
    });
    // render comment box
    _defineProperty(_assertThisInitialized(_this), "_renderCommentBox", function (number, name, dateStr, comment) {
      if ((0, _isNull2["default"])(comment) || (0, _isUndefined2["default"])(comment)) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].commentInfo
      }, /*#__PURE__*/_react["default"].createElement("h2", null, name), /*#__PURE__*/_react["default"].createElement("span", null), /*#__PURE__*/_react["default"].createElement("h3", null, dateStr)), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("p", null, comment));
    });
    _defineProperty(_assertThisInitialized(_this), "_processVal", function (value) {
      if (value === '1') {
        return true;
      }
      if (value === '0') {
        return false;
      }
      if (!(0, _isNil2["default"])(value)) {
        return true;
      }
      return false;
    });
    _defineProperty(_assertThisInitialized(_this), "_renderSessionData", function (row, filter) {
      var formattedData = [];
      (0, _filter2["default"])(_this.props.child.sessions, function (s) {
        return s.type === filter;
      }).forEach(function (session) {
        if ((0, _isNil2["default"])((0, _get2["default"])(session, row.dataPath))) {
          formattedData.push(_this._renderNull());
        } else {
          formattedData.push(_this._renderBinaryCell(!(0, _isNil2["default"])((0, _get2["default"])(session, row.dataPath)) ? _this._processVal((0, _get2["default"])(session, row.dataPath)) : false, _this._processVal((0, _get2["default"])(session, row.dataPath)) ? row.icons["true"] : row.icons["false"]));
        }
      });
      return formattedData;
    });
    _defineProperty(_assertThisInitialized(_this), "_getCommentsForSessions", function (commentType) {
      var formattedData = [];
      (0, _filter2["default"])(_this.props.child.sessions, function (s) {
        return s.type === commentType.sessionFilter;
      }).forEach(function (session) {
        var commentData = _this._renderCommentBox(session.tableLabel, session.label, session.date, session.comments);
        if (!(0, _isNull2["default"])(commentData)) {
          formattedData.push(commentData);
        }
      });
      if ((0, _isEmpty2["default"])(formattedData)) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].fade
        }, "No comment data");
      }
      return formattedData;
    });
    return _this;
  }
  _createClass(LogReport, [{
    key: "render",
    value:
    // final render
    function render() {
      var _this2 = this;
      var isReport = this.props.isReport;
      var reportStyle = isReport ? _style["default"].report + ' ' + _style["default"].paginated : _style["default"].report;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: reportStyle
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Report, {
        showPagination: isReport
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].toPdf
      }, this.props.reportProps.tables.map(function (table, index) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, null, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].reportContentWrapper
        }, (isReport || index === 0) && _this2.props.header, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].contentWrapper
        }, (isReport || index === 0) && /*#__PURE__*/_react["default"].createElement("p", null, _this2.props.reportProps.description), /*#__PURE__*/_react["default"].createElement("div", {
          key: index,
          className: _style["default"].sessionsArea
        }, /*#__PURE__*/_react["default"].createElement("h1", null, table.tableTitle), /*#__PURE__*/_react["default"].createElement("p", null, table.tableDescription), /*#__PURE__*/_react["default"].createElement("table", {
          className: _style["default"].groupTable
        }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", {
          rowSpan: "2",
          className: _style["default"].leftAlign + ' ' + _style["default"].bottomVert
        }, table.rowColTitle), /*#__PURE__*/_react["default"].createElement("th", {
          colSpan: "10"
        }, _this2.props.reportProps.sessionLabelPlural)), /*#__PURE__*/_react["default"].createElement("tr", {
          className: _style["default"].numbersHeaderRow
        }, (0, _filter2["default"])(_this2.props.child.sessions, function (s) {
          return s.type === table.sessionFilter;
        }).map(function (session, i) {
          return /*#__PURE__*/_react["default"].createElement("th", {
            key: i
          }, session.tableLabel);
        }))), /*#__PURE__*/_react["default"].createElement("tbody", null, (0, _sortBy2["default"])(table.rows.map(function (row, i) {
          return /*#__PURE__*/_react["default"].createElement("tr", {
            key: i
          }, /*#__PURE__*/_react["default"].createElement("td", {
            className: _style["default"].leftAlign
          }, row.label), _this2._renderSessionData(row, table.sessionFilter));
        }), [function (t) {
          return t.order;
        }])))))));
      }), this.props.reportProps.comments && this.props.reportProps.commentTypes.map(function (commentType, index) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, {
          key: index
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].reportContentWrapper
        }, isReport && _this2.props.header, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].contentWrapper
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].commentsArea
        }, /*#__PURE__*/_react["default"].createElement("h1", null, "Comments"), /*#__PURE__*/_react["default"].createElement("div", {
          key: index
        }, /*#__PURE__*/_react["default"].createElement("h2", null, commentType.label), _this2._getCommentsForSessions(commentType))))));
      }))));
    }
  }]);
  return LogReport;
}(_react.Component);
LogReport.propTypes = {
  // the active child
  child: _propTypes["default"].object,
  // props pass through from appdefs
  reportProps: _propTypes["default"].object,
  // Full rendered markup for the header
  header: _propTypes["default"].node,
  // whether to render in report page
  isReport: _propTypes["default"].bool
};
var _default = exports["default"] = LogReport;